import { Injectable, inject } from '@angular/core';
import { Logger } from '@nsalaun/ng-logger';
import { BehaviorSubject, Observable, fromEvent } from 'rxjs';
import { skip, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class FreezeResumeService {
	private logger = inject(Logger);

	private isFrozen$ = new BehaviorSubject<boolean>(false);

	constructor() {
		fromEvent(window, 'freeze')
			.pipe(tap(() => this.logger.debug('[FreezeResumeService] says freeze event triggered')))
			.subscribe(() => this.isFrozen$.next(true));
		fromEvent(window, 'resume')
			.pipe(tap(() => this.logger.debug('[FreezeResumeService] says resume event triggered')))
			.subscribe(() => this.isFrozen$.next(false));
	}

	isFrozen(): Observable<boolean> {
		// first is always false because of BehaviourSubject's initial value
		// second one is the initial event triggered, which should be ignored, too
		return this.isFrozen$.asObservable().pipe(skip(2));
	}
}
